const insuranceCasePageResources = {
  en: {
    insuranceCasePage: {
      insuranceInfo:
        'Information about the insured event. Enter the phone number, describe the situation if necessary, attach photos and specify the location',
      contactInfo: 'Contact information',
      fullName: 'Full Name',
      enterFullName: 'Enter your full name',
      phoneNumber: 'Phone number',
      insuranceCaseInfo: 'Information on the insured event',
      insuranceType: 'Type of insurance',
      other: 'Other',
      uniquePolicyNumber: 'Unique policy number',
      whereAreYou: 'Where are you located?',
      enterAddress: 'Region, city, street',
      selectNearestBranch: 'Select the branch closest to you',
      insuranceCaseDescription: 'Description of the insured event',
      enterDescription: 'Enter a description of the insured event',
      searchResult: 'Search result:',
      uniqueNumber: 'Unique number',
      photosFromAccidentScene: 'Photos from the scene of the accident',
      attachment: 'Attachment',
      attachPhotosInfo:
        'Please attach photos from the scene, you can attach up to 5 photos.',
      attachPhotosInfo2:
        'The size of the downloaded file should not exceed 5 MB, only files with the extension .jpg, .jpeg, .png, .svg, .webp, .doc, .docx, .xls, .xlsx, .pdf are available.',
      attachPhotosInfo3:
        "You can use your phone's camera if it supports this feature.",
      attachPhoto: 'Attach a photo',
      geolocation: 'Geolocation',
      geolocationInfo:
        'You can send us your location if your device supports this feature.',
      send: 'Send',
      notificationSuccess:
        'The notification of the insured event has been successfully sent! Our staff will contact you in the near future.',
      notificationDescription:
        'If you have any additional questions, please contact our contact center.',
      addPhoto: 'Add photo',
      yourLocationSaved: 'Your location saved!',
      yourCoordinates: 'Your coordinates:',
      determineMyLocation: 'Determine my location',
      sendRequest: 'Send request',
      areYouSure: 'Are you sure you want to send a request?',
      health: 'Voluntary health insurance',
      validateFullName: 'Enter your full name',
      validatePhone: 'Enter phone number',
      validateRegion: 'Select region',
      validatePolicy: 'Enter policy number',
      validateAddress: 'Enter address',
      validateDescription: 'Enter a description of the insured event',
      validateType: 'Select type of insurance',
    },
  },
  kz: {
    insuranceCasePage: {
      insuranceInfo:
        'Сақтандыру жағдайы туралы ақпарат. Телефон нөмірін енгізіңіз, жағдайды сипаттаңыз, фотосуреттерді тіркеңіз және орналасқан жеріңізді көрсетіңіз',
      contactInfo: 'Байланыс ақпараты',
      fullName: 'Толық аты-жөніңіз',
      enterFullName: 'Аты-жөніңізді енгізіңіз',
      phoneNumber: 'Телефон нөмірі',
      insuranceCaseInfo: 'Сақтандыру жағдайы бойынша ақпарат',
      insuranceType: 'Сақтандыру түрі',
      other: 'Басқа',
      uniquePolicyNumber: 'Бірегей саясат нөмірі',
      whereAreYou: 'Сіз қай жердесіз?',
      enterAddress: 'Аймақ, Қала, Көше',
      selectNearestBranch: 'Сізге жақын филиалды таңдаңыз',
      insuranceCaseDescription: 'Сақтандыру жағдайының сипаттамасы',
      enterDescription: 'Сақтандыру жағдайының сипаттамасын енгізіңіз',
      searchResult: 'Іздеу нәтижесі:',
      uniqueNumber: 'Бірегей нөмір',
      photosFromAccidentScene: 'Оқиға орнындағы фотосуреттер',
      attachment: 'Тіркеме',
      attachPhotosInfo:
        'Оқиға орнынан фотосуреттерді тіркеуді сұраймыз, сіз 5 фотосуретке дейін қоса аласыз.',
      attachPhotosInfo2:
        'Жүктелетін файлдың өлшемі 5 МБ-тан аспауы керек, тек кеңейтімі бар файлдар қол жетімді .jpg, .jpeg, .png, .svg, .webp, .doc, .docx, .xls, .xlsx, .pdf.',
      attachPhotosInfo3:
        'Мүмкіндік болса, телефон камерасын пайдалануға болады',
      attachPhoto: 'Фотосуретті тіркеу',
      geolocation: 'Геолокация',
      geolocationInfo:
        'Егер сіздің құрылғыңыз осы мүмкіндікті қолдаса, бізге орналасқан жеріңізді жібере аласыз',
      send: 'Жіберу',
      notificationSuccess:
        'Сақтандыру жағдайы туралы хабарлама сәтті жіберілді! Жақын арада сізбен біздің қызметкерлер байланысады.',
      notificationDescription:
        'Қосымша сұрақтар туындаған жағдайда біздің байланыс орталығына хабарласыңыз.',
      addPhoto: 'Фотосурет қосу',
      yourLocationSaved: 'Сіздің орналасқан жеріңіз сақталды!',
      yourCoordinates: 'Сіздің координаттарыңыз:',
      determineMyLocation: 'Менің орналасқан жерімді анықтау',
      sendRequest: 'Өтініш жіберу',
      areYouSure: 'Сіз өтініш жібергіңіз келетініне сенімдісіз бе?',
      health: 'Ерікті медициналық сақтандыру',
      validateFullName: 'Аты-жөнінңізді енгізіңіз',
      validatePhone: 'Телефон нөміріңізді енгізіңіз',
      validateRegion: 'Аймақты таңдаңыз',
      validatePolicy: 'Полис нөмірін енгізіңіз',
      validateAddress: 'Сақтандыру жағдайы болған мекенжайды енгізіңіз',
      validateDescription: 'Сақтандыру жағдайының сипаттамасын енгізіңіз',
      validateType: 'Сақтандыру түрін таңдаңыз',
    },
  },
  ru: {
    insuranceCasePage: {
      insuranceInfo:
        'Информация о страховом случае. Введите номер телефона, при необходимости опишите ситуацию, приложите фотографии и укажите местоположение',
      contactInfo: 'Контактная информация',
      fullName: 'ФИО',
      enterFullName: 'Введите ФИО',
      phoneNumber: 'Номер телефона',
      insuranceCaseInfo: 'Информация по страховому случаю',
      insuranceType: 'Вид страхования',
      other: 'Иное',
      uniquePolicyNumber: 'Уникальный номер полиса',
      whereAreYou: 'Где вы находитесь?',
      enterAddress: 'Регион, город, улица',
      selectNearestBranch: 'Выберите ближайший к вам филиал',
      insuranceCaseDescription: 'Описание страхового случая',
      enterDescription: 'Введите описание страхового случая',
      searchResult: 'Результат поиска:',
      uniqueNumber: 'Уникальный номер',
      photosFromAccidentScene: 'Фотографии с места происшествия',
      attachment: 'Вложение',
      attachPhotosInfo:
        'Просим прикрепить фотографии с места происшествия, можно прикрепить до 5 фото.',
      attachPhotosInfo2:
        'Размер загружаемого файла не должен превышать 5 МБ, доступны только файлы с расширением .jpg, .jpeg, .png, .svg, .webp, .doc, .docx, .xls, .xlsx, .pdf.',
      attachPhotosInfo3:
        'Можно воспользоваться камерой телефона, если эту функцию он поддерживает',
      attachPhoto: 'Прикрепить фото',
      geolocation: 'Геолокация',
      geolocationInfo:
        'Вы можете отправить нам своё местоположение, если ваше устройство поддерживает эту функцию',
      send: 'Отправить',
      notificationSuccess:
        'Уведомление о страховом случае успешно отправлено! В ближайшее время с Вами свяжутся наши сотрудники.',
      notificationDescription:
        'В случае возникновения дополнительных вопросов, свяжитесь с нашим контакт-центром.',
      addPhoto: 'Добавить фото',
      yourLocationSaved: 'Ваше местоположение сохранено!',
      yourCoordinates: 'Ваши координаты:',
      determineMyLocation: 'Определить мое местоположение',
      sendRequest: 'Отправить заявку',
      areYouSure: 'Вы уверены, что хотите отправить заявку?',
      health: 'Добровольное медицинское страхование',
      validateFullName: 'Введите ФИО',
      validatePhone: 'Введите номер телефона',
      validateRegion: 'Выберите регион',
      validatePolicy: 'Введите номер полиса',
      validateAddress: 'Введите адрес',
      validateDescription: 'Введите описание страхового случая',
      validateType: 'Выберите вид страхования',
    },
  },
};

export default insuranceCasePageResources;
